import React from 'react'
import { useTranslation } from "next-i18next";
import Head from 'next/head';
import Layout from '@/components/shared/Layout'
import PeerstackImage from '../../public/images/Peerstack 1200x630.jpeg';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'
import Link from 'next/link';

const SECTIONS = [
    { id: 1, blocks: ['content-1'] },
    {
        id: 2,
        blocks: [
            'content-1', 'content-2', '1',
            '1-1', '1-2', '1-3', '1-4', '1-5', '1-6', '1-7',
            '1-8', '1-9', '1-10', '1-11', '1-12', '1-13', '1-14',
            '2',
        ],
    },
    { id: 3, blocks: ['content-1', '1'] },
    { id: 4, blocks: ['content-1'] },
    { id: 5, blocks: ['content-1'] },
]

const CONTACT_SECTION = 6
const PARAGRAPH = 'text-[15px] md:text-[16px] text-[#4b5563] leading-[1.85]'

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale || "az")),
        },
    };
}

const TermsOfConditionsPage = () => {
    const { t } = useTranslation();
    return (
        <>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{t("terms-page.meta-title")}</title>
                <meta name="keywords" content="peerstack tech terms conditions" />
                <meta name="description" content={t("terms-page.meta-description")} />
                <meta name="image" content={PeerstackImage.src} />
                <link rel="canonical" href="https://peerstack.tech/terms-of-conditions" />
                <meta property="og:site_name" content="peerstack.tech" />
                <meta property="og:title" content={t("terms-page.meta-title")} />
                <meta property="og:url" content="https://peerstack.tech/terms-of-conditions" />
                <meta property="og:description" content={t("terms-page.meta-description")} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={PeerstackImage.src} />
            </Head>
            <Layout>
                <div className="pt-[40px] pb-[70px] md:pt-[56px] md:pb-[96px]">
                    <div className="w-[90%] mx-auto">
                        <h1 className="text-[30px] md:text-[38px] font-semibold text-center text-main mb-[28px] md:mb-[36px]">
                            {t("terms-page.page-title")}
                        </h1>

                        <p className={`${PARAGRAPH} mb-[24px]`}>
                            {t("terms-page.intro")}
                        </p>

                        <ol className="flex flex-col gap-[24px]">
                            {SECTIONS.map(({ id, blocks }) => (
                                <li key={id}>
                                    <h2 className="text-[19px] md:text-[22px] font-semibold text-main mb-[8px]">
                                        {id}. {t(`terms-page.section-${id}-title`)}
                                    </h2>
                                    <div className="pl-[8px] flex flex-col gap-[8px]">
                                        {blocks.map(block => {
                                            const isClause = !block.startsWith('content')
                                            const label = isClause ? `${id}.${block.split('-').join('.')}. ` : ''
                                            const indent = isClause ? (block.split('-').length - 1) * 16 : 0
                                            return (
                                                <div
                                                    key={block}
                                                    className={PARAGRAPH}
                                                    style={{ paddingLeft: indent }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: label + t(`terms-page.section-${id}-${block}`),
                                                    }}
                                                />
                                            )
                                        })}
                                    </div>
                                </li>
                            ))}

                            <li>
                                <h2 className="text-[19px] md:text-[22px] font-semibold text-main mb-[8px]">
                                    {CONTACT_SECTION}. {t(`terms-page.section-${CONTACT_SECTION}-title`)}
                                </h2>
                                <div className="pl-[8px] flex flex-col gap-[8px]">
                                    <p className={PARAGRAPH}>
                                        {t(`terms-page.section-${CONTACT_SECTION}-content-1`)}
                                    </p>
                                    <p className={PARAGRAPH}>
                                        {t(`terms-page.section-${CONTACT_SECTION}-address-label`)} - {t(`terms-page.section-${CONTACT_SECTION}-address`)}
                                    </p>
                                    <p className={PARAGRAPH}>
                                        {t(`terms-page.section-${CONTACT_SECTION}-contact-label`)} -{' '}
                                        <Link href="tel:+994552508887" className="text-[#1053F3] hover:underline">+994 (55) 250 88 87</Link>
                                        {' / '}
                                        <Link href="mailto:info@peerstack.tech" className="text-[#1053F3] hover:underline">info@peerstack.tech</Link>
                                    </p>
                                </div>
                            </li>
                        </ol>

                        <p className="text-[14px] md:text-[15px] text-[#6b7280] italic mt-[28px]">
                            {t("terms-page.last-updated")}
                        </p>
                    </div>
                </div>

                <ScrollToTopButton />
                <WhatsappButton />
            </Layout>
        </>
    )
}

export default TermsOfConditionsPage
